import { Component, HostListener, ElementRef } from '@angular/core';
import { HeaderComponent } from '../header/header.component';
import { Router, NavigationEnd, NavigationExtras } from '@angular/router';

import { FooterComponent } from '../footer/footer.component';
import { Observable } from 'rxjs';
import { ApidataService } from '../apidata.service';
import { Http, Headers, Response, RequestOptions } from '@angular/http';
import {
  HttpClient,
  HttpClientModule,
  HttpHeaders,
} from '@angular/common/http';
import swal from 'sweetalert2';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';
import { RecaptchaModule, RECAPTCHA_SETTINGS } from 'ng-recaptcha';
import {
  FormBuilder,
  FormGroup,
  Validators,
  FormControl,
  AbstractControl,
  FormGroupDirective,
  NgForm,
} from '@angular/forms';
import { data } from 'jquery';
import { RouterLink } from '@angular/router';
import { RouterModule } from '@angular/router';
import { filter } from 'rxjs/operators';
import { environment, GINConstants } from '../../environments/environments';
declare const gapi: any;
declare var FB: any;
@Component({
  selector: 'app-signin',
  standalone: true,
  imports: [
  
    HttpClientModule,
    CommonModule,
    ReactiveFormsModule,
    RecaptchaModule,
    RouterModule,
  ],
  templateUrl: './signin.component.html',
  styleUrl: './signin.component.css',
  providers: [ApidataService],
})
export class SigninComponent {
  [x: string]: any;
  public nodata: boolean = false;
  logins;
  profile_id;
  captchaResponse: string;
  public section = '';
  public checkLogin = false;
  public auth2: any;
  login;
  recaptchaSiteKey = '6LcMnOsnAAAAAExxnt0IqIEq4pSha6O_vPeOsw-1';
  user;
  idgoogle;
  pass;
  loginid;
  returnUrl: string;
  public docTitle = '';
  public doc_id = '';
  authentication_token;
  recaptcha_message = ""
  got_recpatcha : boolean = false;
  captchaToken: string | null = null;
  passwordFieldType: string = 'password';
  password: string = '';
  color = "";
  constructor(
    private router: Router,
    private apirequest: ApidataService,
    private elementRef: ElementRef
  ) {
    this.router.events
      .pipe(filter((event) => event instanceof NavigationEnd))
      .subscribe(() => {
        window.scrollTo({ top: 0, behavior: 'smooth' });
      });
  }
  ngOnInit() {
    this.logins = new FormGroup({
      login_email: new FormControl(),
      login_password: new FormControl(),
    });
  }
  public ngAfterViewInit(): void {
    this.loadTurnstileScript().then(() => this.renderTurnstile());}
  navigateTosignup() {
    this.router.navigate(['/signup']);
  }
  navigateToHome() {
    this.router.navigate(['']);
  }
  navigateTosiforgot() {
    this.router.navigate(['/forgot-password']);
  }
  onCaptchaResolved(captchaResponse: string) {
    this.captchaResponse = captchaResponse;
  }
  public eLogin() {
    let login_email = $('#login_email').val();
    let login_password = $('#login_password ').val();
    if (login_email === '' || login_password === '') {
      $('#dangerAlert').html('Please provide the required fields');
      $('#dangerAlert').show();
      this.nodata = true;
      setTimeout(function () {
        $('#dangerAlert').hide();
      }, 3000);
    }
    if (this.logins.valid) {
      $('#dangerAlert').html('');
      $('#dangerAlert').hide();
      let remember_me = $('#remember_me').val();
      if ($('#remember_me').is(':checked')) {
        let checked = true;
      }
   
      let reg = /^([A-Za-z0-9_\-\.])+\@([A-Za-z0-9_\-\.])+\.([A-Za-z]{2,4})$/;

      if (
        this.logins.value.login_email === '' ||
        this.logins.value.login_password === ''
      ) {
        $('#dangerAlert').html('Please provide the required fields');
        $('#dangerAlert').show();
      }

      if (reg.test(this.logins.value.login_email) === false) {
        $('#dangerAlert2').html('Please provide a valid Email');
        $('#dangerAlert2').show();
      } else if (
        this.logins.value.login_email &&
        this.logins.value.login_password
      ) {
        $('#loginBtn').hide();
        $('#loginProcBtn').show();

        $('#dangerAlert').html('');
        $('#dangerAlert').hide();
        let body = JSON.stringify({
          email: this.logins.value.login_email,
          password: this.logins.value.login_password,
          remember_me: remember_me,
        });
    
        this.apirequest.login(body).subscribe((data) => {
          this.pass = data.response;
      
          if (data.response['meta'].code === 200) {
            this.login = data;
            this.user = this.login.response.response.user;
            this.authentication_token = this.user.authentication_token;
            localStorage.getItem('id');
            localStorage.getItem('token');
            $('#login_email').val('');
            $('#login_password').val('');
          

            this.showSuccess(
              ' You have successfully logged into GrammarIn.',
              ''
            );
            setTimeout(() => {
              this.router.navigate(['/']);
            }, 2000);
        
          } else if (
            data.response['meta'].code === 400 &&
            data.response['response']['errors']['password']
          ) {
            $('#loginBtn').show();
            $('#loginProcBtn').hide();
            $('#dangerAlert2').html('Invalid password');
            $('#dangerAlert2').show();
            setTimeout(function () {
              $('#dangerAlert2').hide();
            }, 4000);

 
          } else if (
            data.response['meta'].code === 400 &&
            data['response']['response']['errors']['email']
          ) {
            $('#loginBtn').show();
            $('#loginProcBtn').hide();
            $('#dangerAlert2').html('Specified user does not exist');
            $('#dangerAlert2').show();
            setTimeout(function () {
              $('#dangerAlert2').hide();
            }, 4000);

        
          } else if (
            data.response['meta'].code === 401 &&
            data.response.meta.message
          ) {
            $('#loginBtn').show();
            $('#loginProcBtn').hide();
            $('#dangerAlert2').html(
              "There's already a GrammarIn account associated with this email through a social sign-in method. Please choose a social provider above to sign in."
            );
            $('#dangerAlert2').show();
            setTimeout(function () {
              $('#dangerAlert2').hide();
            }, 4000);
          } else if (
            data.response.code === 401 &&
            data.response.meta === 'Please verify your account first.'
          ) {
            $('#loginBtn').show();
            $('#loginProcBtn').hide();
            $('#dangerAlert2').html('Please verify your account first.');
            $('#dangerAlert2').show();
            setTimeout(function () {
              $('#dangerAlert2').hide();
            }, 4000);

        
          } else {
            $('#loginBtn').show();
            $('#loginProcBtn').hide();

            $('#dangerAlert2').html('Invalid Email / Password');
            $('#dangerAlert2').show();
            setTimeout(function () {
              $('#dangerAlert2').hide();
            }, 4000);
       
          }
        });
      }
    }
  }

  error: boolean = false;
  errorAlerts;
  success: boolean = false;
  successAlert;

  showAlert(message, selector) {
    this.errorAlerts = message;
    $(selector).css('border-color', 'red');
    this.error = true;
    $('#errorAlerts;').show();
    setTimeout(() => {
      $('#errorAlerts;').hide();
      $(selector).css('border-color', '#e7e7ec');
      this.error = false;
    }, 4000);
    let backdrop = document.querySelector('.modal-backdrop');
    if (!backdrop) {
      backdrop = document.createElement('div');
      backdrop.className = 'modal-backdrop fade show'; 
      document.body.appendChild(backdrop); 
    }
  }

  showSuccess(message, selector) {
    this.successAlert = message;
    this.success = true;
    $('#successAlert').show();
    setTimeout(() => {
      $('#successAlert').hide();
      $(selector).css('border-color', '#e7e7ec');
      this.success = false;
    }, 4000);
  }

  closeErrorDiv() {
    this.error = false;
  }

  public saveTextRedirect(type) {
    let data2 = JSON.stringify({
      homeText: this.docTitle,
      profile_id: this.user.id,
    });
    let url = environment.API_URL+'/api/getNewDocIDbyProfileID';

    this.apirequest.postResources(data2, url).subscribe((data) => {
   
      let receivedData = data;

      this.doc_id = receivedData['new_doc_id'];
      // this.router.navigate(['/document/', this.doc_id]);
      this.router.navigate(['/grammar-check'], { queryParams: { doc: this.doc_id } });
      this.router.serializeUrl(this.router.createUrlTree(['']));
      swal({
        background: '#FFF9EB',
        type: 'success',
        text: 'You have successfully logged into GrammarIn.',
        showConfirmButton: false,
        timer: 2000,
        width: '512px',
      });
      // }
    });
  }

 

  togglePasswordVisibility(): void {
    this.passwordFieldType =
      this.passwordFieldType === 'password' ? 'text' : 'password';
  }
  isDropdownVisible = false;
  selectedLanguage = {
    name: 'English', 
    icon: '../../assets/images/plagiarism checker1/language.svg', 
  };



  @HostListener('document:click', ['$event'])
  handleOutsideClick(event: Event) {
    const target = event.target as HTMLElement;


    if (
      !this.elementRef.nativeElement.contains(target) &&
      !target.classList.contains('dropbtn')
    ) {
      this.isDropdownVisible = false;
    }
  }
  private initializeGoogleAuth(): Promise<void> {
    return new Promise((resolve, reject) => {
      gapi.load('auth2', () => {
        gapi.auth2
          .init({
            client_id:
              '859452103362-3aroha97qk7nt8ps6ocl70k10pj7uuvt.apps.googleusercontent.com', 
          })
          .then(() => {
            resolve();
          })
          .catch((error) => {
            // console.error('Error initializing Google Auth', error);
            reject(error);
          });
      });
    });
  }

  public googleLogin(): void {
    this.initializeGoogleAuth()
      .then(() => {
        const googleAuth = gapi.auth2.getAuthInstance();
        googleAuth
          .signIn({ scope: 'profile email' })
          .then((googleUser) => {
        
            this.onSignIn(googleUser);
          })
          .catch((error) => {
            // console.error('Google Sign-In failed', error);
          });
      })
      .catch((error) => {
        // console.error('Google API initialization failed', error);
      });
  }

  public onSignIn(googleUser): void {
    const profile = googleUser.getBasicProfile();
    const id_token = googleUser.getAuthResponse().id_token;
    const body = {
      firstname: btoa(profile.getGivenName()),
      lastname: btoa(profile.getFamilyName()),
      email: btoa(profile.getEmail()),
    };


    this.gLogin(body);
  }
  public gLogin(body): void {
    this.apirequest.signupinGoogle2(body).subscribe(
      (data) => {
        if (data.meta.code === 200) {
          localStorage.setItem('currentUser', JSON.stringify(data));
          this.user = data['response'];
          this.authentication_token = this.user['user'].authentication_token;
          this.idgoogle = this.user['user'].id;
          localStorage.setItem('fullname', this.user['user'].verify);
          localStorage.setItem(this.idgoogle, 'profile_id');
       
          localStorage.setItem(
            'authentication_token',
            this.user['user'].authentication_token
          );
          localStorage.setItem('token', this.user['user'].authentication_token);

          localStorage.setItem('profile_id', this.idgoogle);

      
          localStorage.setItem('role', '1');
          localStorage.setItem('fullname', this.user['user'].verify);

         

          swal({
            background: '#FFFFFF',
            title: 'success',
            html: `
            <div style="position: fixed; top: 50%; left: 50%; transform: translate(-50%, -50%); width: 468px; height: 360px;
              background-color: white; z-index: 9999999999999999; border-radius: 4px; border: 1px solid #E3E3F0;">
              <div class="text-center" style="margin-top: 9%;">
                <img src="/assets/images/paraphrasing tool/success.svg" alt="Alert" />
                <div style="    width: 369px; height: 64px; margin-left: 39px;">
                  <p class="error mt-4" style="font-size: 20px; font-weight: 500; line-height: 33.89px;">
                  You have successfully logged into GrammarIn.
                  </p>
                </div>
              </div>
            </div>
          `,
            showConfirmButton: false,
            width: '323px',
            timer: 4000,
          });

      
          setTimeout(() => {
            const okButton = document.getElementById('swal-ok-button');
            if (okButton) {
              okButton.addEventListener('click', () => {
                swal.close(); 
              });
            }
          }, 0);
          this.router.navigate(['/']).then(() => {
   
            window.location.reload();
          });

      
        } else if (data.meta.code === 400) {
        
          swal({
            background: '#FFFFFF',
            title: 'Error',
            html: `
          <div style="position: fixed; top: 50%; left: 50%; transform: translate(-50%, -50%); width: 468px; height: 360px;
            background-color: white; z-index: 9999999999999999; border-radius: 4px; border: 1px solid #E3E3F0;">
            <div class="text-center" style="margin-top: 9%;">
              <img src="/assets/images/paraphrasing tool/alert.svg" alt="Alert" />
              <div style="    width: 369px; height: 64px; margin-left: 39px;">
                <p class="error mt-4" style="font-size: 20px; font-weight: 500; line-height: 33.89px;">
                 You have already registered your account from the web.
                </p>
              </div>
              <button id="swal-ok-button" style="color: white; background-color: black; border: 1px solid black;
                border-radius: 8px; width: 150px; height: 50px; font-size: 16px; font-weight: 600;"
                class="mt-5 butn-alert">Ok</button>
            </div>
          </div>
        `,
            showConfirmButton: false,
            width: '323px',
            timer: 4000,
          });

      
          setTimeout(() => {
            const okButton = document.getElementById('swal-ok-button');
            if (okButton) {
              okButton.addEventListener('click', () => {
                swal.close();
              });
            }
          }, 0);
        }
      },
      (error) => {
        // console.error('Login error', error);
      }
    );
  }
  ////// hidden recaptcha strat

loadTurnstileScript(): Promise<void> {
  return new Promise((resolve, reject) => {
    if (typeof window['turnstile'] !== 'undefined') {
      resolve();
      return;
    }

    const script = document.createElement('script');
    script.src = 'https://challenges.cloudflare.com/turnstile/v0/api.js';
    script.async = true;
    script.defer = true;
    script.onload = () => resolve();
    script.onerror = () => reject('Failed to load Turnstile script');
    document.body.appendChild(script);
  });
}

renderTurnstile(): void {
  if (typeof window['turnstile'] !== 'undefined') {
    window['turnstile'].render('#recaptcha-container', {
      sitekey: environment.CaptchaKey, 
      size: 'normal', 
      callback: (token: string) => this.onTurnstileSuccess(token),
      'error-callback': () => this.onTurnstileError(),
    });
   
  } else {
    // console.error('Turnstile script not loaded.');
  }
}


handleButtonClick(): void {
  if (this.captchaToken) {
  

    this.got_recpatcha = false;
    this.eLogin();
  } else {
    this.got_recpatcha = true;
  
    $('#dangerAlert').html('Captcha is not loaded. Please reload the page.');
    $('#dangerAlert').show();
    this.nodata = true;
    setTimeout(function () {
      $('#dangerAlert').hide();
    }, 3000);
  
  }
}


onTurnstileSuccess(token: string): void {
  // console.log('Turnstile token received:', token);
  this.captchaToken = token; 
}

// Error callback when CAPTCHA fails
onTurnstileError(): void {
  // console.error('Turnstile error occurred.');
  this.captchaToken = null; 
}


///// recaptcha end

}
